module.exports = __webpack_public_path__ + "img/logo.8a16d26c.png";